const Spiner = () => (
  <div className='spinner-border text-primary' role='status'>
    <span className='sr-only'>Loading...</span>
  </div>
)

export { Spiner }
